var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"x-data-table-fix-action-col"},[_c('x-data-table',{attrs:{"x-options":_vm.tableOptions,"x-container":_vm.tableContainer,"x-context":_vm.self}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }